import { Link } from 'react-router-dom';
import Button from '../../../components/base/Button';

export default function CTASection() {
  return (
    <section className="py-20 bg-gradient-to-br from-orange-600 via-red-600 to-orange-700">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center text-white">
          <div className="inline-block bg-white/20 backdrop-blur-sm px-6 py-3 rounded-full text-sm font-bold mb-6">
            <i className="ri-calendar-event-line mr-2"></i>
            PRÓXIMA RENOVACIÓN: DÍA 1 DEL MES
          </div>
          <h2 className="text-4xl md:text-5xl font-bold mb-6">
            No Te Pierdas las Próximas Ofertas Flash
          </h2>
          <p className="text-xl text-white/90 mb-8 max-w-2xl mx-auto">
            Cada día 1 del mes lanzamos nuevos packs exclusivos con descuentos brutales. Stock limitado, primero en llegar, primero en comprar.
          </p>
          
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 max-w-4xl mx-auto mb-12">
            <div className="bg-white/10 backdrop-blur-md rounded-xl p-6 border border-white/20">
              <div className="w-16 h-16 bg-white rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-calendar-check-line text-3xl text-orange-600"></i>
              </div>
              <h3 className="text-xl font-bold mb-2">Día 1 del Mes</h3>
              <p className="text-white/80">Nuevas ofertas cada mes</p>
            </div>

            <div className="bg-white/10 backdrop-blur-md rounded-xl p-6 border border-white/20">
              <div className="w-16 h-16 bg-white rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-box-3-line text-3xl text-orange-600"></i>
              </div>
              <h3 className="text-xl font-bold mb-2">Stock Limitado</h3>
              <p className="text-white/80">Cantidades muy limitadas</p>
            </div>

            <div className="bg-white/10 backdrop-blur-md rounded-xl p-6 border border-white/20">
              <div className="w-16 h-16 bg-white rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-percent-line text-3xl text-orange-600"></i>
              </div>
              <h3 className="text-xl font-bold mb-2">Hasta 70% OFF</h3>
              <p className="text-white/80">Descuentos increíbles</p>
            </div>
          </div>

          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
            <Link to="/paquetes">
              <Button 
                size="lg"
                className="min-w-[250px] bg-white text-orange-600 hover:bg-gray-100"
              >
                <i className="ri-flashlight-line mr-2"></i>
                Ver Ofertas Actuales
              </Button>
            </Link>
            <Link to="/contacto">
              <Button 
                size="lg"
                variant="outline"
                className="min-w-[250px] bg-white/10 backdrop-blur-sm border-white text-white hover:bg-white hover:text-orange-600"
              >
                <i className="ri-notification-3-line mr-2"></i>
                Recibir Notificaciones
              </Button>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}